import { Box, theme } from '@/components';
import type { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  paddingTop?: number;
  paddingBottom?: number;
  borderBottom?: string | number;
};
export const ContentItem: FC<Props> = ({
  children,
  paddingTop,
  paddingBottom,
  borderBottom,
}) => {
  const { token } = theme.useToken();
  return (
    <Box width="100%">
      <Box
        paddingTop={paddingTop ?? 32}
        paddingBottom={paddingBottom ?? 32}
        borderBottom={borderBottom ?? `1px solid ${token.colorBorder}`}
      >
        {children}
      </Box>
    </Box>
  );
};
